export function capitalize(word: string): string {
    if (word === undefined || word === null) {
        return
    }

    return word[0].toUpperCase() + word.slice(1).toLowerCase()
}
